import React from 'react';
import { Link } from 'react-router-dom';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-green-50">
      <div className="max-w-md w-full mx-4">
        <div className="text-center mb-8">
          <img
            src="/torneopadel.png"
            alt="TorneoPadel"
            className="w-32 h-32 md:w-40 md:h-40 mx-auto mb-4 object-contain"
          />
          <p className="text-gray-600">Únete a torneos de pádel con facilidad</p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 space-y-4">
          <div className="space-y-3">
            <input
              type="text"
              placeholder="Ingresa código de invitación"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  const code = (e.target as HTMLInputElement).value.toUpperCase();
                  if (code) {
                    window.location.href = `/join/${code}`;
                  }
                }
              }}
            />
            <button 
              onClick={() => {
                const input = document.querySelector('input') as HTMLInputElement;
                const code = input?.value.toUpperCase();
                if (code) {
                  window.location.href = `/join/${code}`;
                }
              }}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-4 rounded-lg transition duration-200"
            >
              Unirse al Torneo
            </button>
          </div>
        </div>
        
        <div className="mt-6 text-center text-sm text-gray-500">
          Recibe notificaciones y actualizaciones por WhatsApp
        </div>
      </div>
    </div>
  );
};

export default HomePage;